export const SET_CALCULATOR_DATA = "SET_CALCULATOR_DATA";
export const SET_SELECTED_VESSELS = "SET_SELECTED_VESSELS";
export const SET_PORT_OPERATIONS = "SET_PORT_OPERATIONS";
export const SET_FLEET_LIST = "SET_FLEET_LIST";
export const SET_SELECTED_QUERY = "SET_SELECTED_QUERY";
export const SET_SYNC_BUNKER = "SET_SYNC_BUNKER";
export const SET_IS_OVERRIDE = "SET_IS_OVERRIDE";
export const SET_ESTIMATION_EST_ID = "SET_ESTIMATION_EST_ID";
export const SET_SPLIT_HIRE_ARRAY = "SET_SPLIT_HIRE_ARRAY";
export const SET_PORT_DISTANCE_RESPONSE = "SET_PORT_DISTANCE_RESPONSE";
export const SET_REAL_PORT_DISTANCE_RESPONSE = "SET_REAL_PORT_DISTANCE_RESPONSE";
export const SET_PORT_DISTANCE_PAYLOAD_RESPONSE = "SET_PORT_DISTANCE_PAYLOAD_RESPONSE";
export const RESET_STORE = "RESET_STORE";
